export interface InitialState {
  mediaStream: MediaStream | null;
  micData: number;
  retakes: number;
  webWorker: Worker | null
  retakeSpeed: number;
}

export const enum STATES {
  INACTIVE = 'inactive',
  ACTIVE = 'active',
  NOT_RECEIVING_DATA = 'notReceivingData',
  RECEIVING_DATA = 'receivingData',
  DATA_CHECK = 'dataCheck',
}

export const enum ACTIONS {
  SET_DETECTION_SPEED = 'setDetectionSpeed',
  COLLECT_BREADCRUMB = 'collectBreadcrumb',
  INIT_WEB_WORKER = 'initWebWorker',
  CONSOLE_LOG = 'consoleLog',
  SET_MEDIA_STREAM = 'setMediaStream',
  UPDATE_MIC = 'updateMic',
  UPDATE_RETAKES = 'UPDATE_RETAKES',
  CLEAN_RETAKES = 'CLEAN_RETAKES',
  SENTRY = 'sentry',
}

export const enum EVENTS {
  ON_DETECTION_SPEED = 'ON_DETECTION_SPEED',
  UNMUTE = 'UNMUTE',
  MUTE = 'MUTE',
  ON_SET_MEDIA_STREAM = 'ON_SET_MEDIA_STREAM',
  SEND_DATA = 'SEND_DATA',
  MIC_CHECK = 'MIC_CHECK',
  SEND_ERROR = 'SEND_ERROR',
  UPDATE_RETAKES = 'UPDATE_RETAKES',
  CLEAN_RETAKES = 'CLEAN_RETAKES',
}

export const enum SERVICES {
  CHECK_MICROPHONE_LEVEL = 'checkMicrophoneLevel',
}

export const enum GUARDS {
  IS_MEDIA_STREAM_AVAILABLE = 'isMediaStreamAvailable',
  IS_MIC_NOT_RECEIVING_DATA = 'isMicNotReceivingData',
  IS_MIC_RECEIVING_DATA = 'isMicReceivingData',
}
